import { PlanPoliciesOutcome, RunPolicyReceipt } from "types/generated";

import { RunElementType, RunEntryContext } from "../types";
import { canShowElement } from "./elements";
import PlanPoliciesEntry from "../entries/PlanPoliciesEntry";
import { getPolicyEvaluation } from "../entries/PlanPoliciesEntry/utils";

export const createPlanPoliciesEntry = (
  list: RunPolicyReceipt[],
  outcome: PlanPoliciesOutcome | null,
  { isSimpleView, stackId, runId, isModuleRun }: RunEntryContext
) => {
  const evaluation = getPolicyEvaluation(list);

  // Simple view hides the entry without an outcome, or when it passed with no info messages
  if (
    isSimpleView &&
    (outcome === null || (!evaluation.isImportant && outcome.info.length === 0))
  ) {
    return null;
  }

  const lastPlan = list[list.length - 1];

  return (
    <PlanPoliciesEntry
      key={lastPlan.id}
      list={list}
      openListByDefault={canShowElement(RunElementType.PlanPolicies)}
      outcome={outcome}
      isSimpleView={isSimpleView}
      evaluationLabel={evaluation.label}
      evaluationBadgeVariant={evaluation.badgeVariant}
      evaluationTimestamp={evaluation.timestamp}
      stackId={stackId}
      runId={runId}
      isModuleRun={isModuleRun}
    />
  );
};
